import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { submitFeedback, fetchMyFeedback, type FeedbackDto, type MyFeedbackQuery } from '../api/feedback';
import { aiQueryKeys } from './query-keys';

export const useSubmitFeedback = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: FeedbackDto) => submitFeedback(dto),
    onSuccess: (_row, dto) => {
      const cardRef = dto.targetRef && 'pluginId' in dto.targetRef ? dto.targetRef : undefined;
      qc.invalidateQueries({
        queryKey: aiQueryKeys.feedback({
          targetKind: dto.targetKind,
          threadId: dto.threadId ?? undefined,
          messageId: dto.messageId ?? undefined,
          pluginId: cardRef?.pluginId,
          entityType: cardRef?.entityType,
          entityId: cardRef?.entityId,
        }),
      });
    },
  });
};

export const useMyFeedback = (q: MyFeedbackQuery & { enabled?: boolean }) =>
  useQuery({
    queryKey: aiQueryKeys.feedback(q),
    queryFn: () => fetchMyFeedback(q),
    enabled: q.enabled !== false,
    staleTime: 60_000,
  });
